import React, { useContext, useState, useEffect } from "react";
import { Box, TextField } from "@mui/material";
import * as yup from "yup";
import moment from 'moment';

const EditableFieldValue = ({ item , celda, handleEditableFieldValue }) => {

  const [valoracion, setValoracion] = useState(item);
  const [error, setError] = useState("");

    const validacionSchema = yup.number()
    .required("Por favor ingrese un valor numérico").typeError("Debe ser un número")
    .min(0, "El valor no puede ser negativo")
    .max(100, "El valor debe ser como máximo 100")

  const currentDate = moment();
  const currentMonth = currentDate.format('MMMM');
  const isFeedbackliderDisabled = celda?.new_mes?.toLowerCase() !== currentMonth.toLowerCase();

  const handleChange = (e) => {
    const inputValue = e.target.value;
    item = e.target.value;
    setValoracion(inputValue);
  

    validacionSchema
      .validate(inputValue)
      .then(() => {
        setError("");
      })
      .catch((err) => {
        setError(err.message);
      });
    
    handleEditableFieldValue(celda.id, inputValue);

  };



  return (
    <Box>
      <TextField
        label="Valor"
        value={valoracion}
        onChange={handleChange}
        variant="standard"
        fullWidth
        InputProps={{ style: { fontSize: ".8rem" } }}
        error={!!error}
        helperText={error}
        disabled={isFeedbackliderDisabled || celda.new_status === 100000001 || celda.new_status === 100000003 || !celda.isLider || celda.estadoTerceraEtapa === 100000001 || celda.new_scoreglobaldeobjetivos }
      />
    </Box>
  );
};

export default EditableFieldValue;
